<div class="full-height full-width">
    <div class="row full-width centerWithFlex zero-margin topPaddingForComp" style="height: 15%;">
        <!-- <div class="full-width vert-center justify-end zero-padding" style="height: 10%;">
            <mat-icon matTooltip="Close popup" color="red" (click)="closePop($event, false)">close</mat-icon>
        </div> -->
        <div class="centerWithFlex" style="width: 60%; height: 60%;">
            <img class="full-height full-width" src="../assets/vaadude_old.png" />
        </div>
    </div>
   
    <div *ngIf="isLogin" class="centerWithFlex full-width topPaddingForComp" >
        <div class="full-height" style="width: 100%; display: grid;">
            <label class="fieldTopBottomPadding">Email</label>
            <div class="full-width vert-center zero-padding">
                <input type="text" id="user-name" name="user-name"  [tabIndex]="1" class="form-control" (keyup)="handleUsName($event)" [(ngModel)]="userName">
            </div>
            <div class="full-width display-flex fieldTopBottomPadding">
                <span *ngIf="userNameReq" class="login-error-div">UserName is required</span>
            </div>
        </div>
    </div>
    <div *ngIf="isLogin" class="centerWithFlex full-width" >
        <div class="full-height" style="width: 100%; display: grid;">
            <label class="fieldTopBottomPadding" >Password</label>
            <div class="full-width vert-center zero-padding">
                <!-- <span style="width: 50%; font-size: 14px;">Password</span> -->
                <input type="password" id="pass" name="pass"  [tabIndex]="1" class="form-control" (keyup)="handlePass($event)" [(ngModel)]="password">
            </div>
            <div class="full-width display-flex fieldTopBottomPadding">
                <span *ngIf="passReq" class="login-error-div">Password is required</span>
                <span *ngIf="cnfPasswordInvalid" class="sign-error-div">Invalid UserName/Password</span>

            </div>
        </div>
    </div>
    <div *ngIf="isLogin" class="full-width vert-center" style="height: 5%;">
        <span style="text-align: end; color: #29088d; text-decoration: underline;" class="pointer-cursor" (click)="forgetPassword()"><i>Forgot password</i></span>
    </div>
    <div *ngIf="isLogin" class="full-width topPaddingForComp" style="height: 20%;display: flex;justify-content: center;align-items: center;">
       
            <!-- <button style="font-size: medium;background-color: green;color: white;width: 100%;" class="btn btn-outline-secondary  button-align" (click)="login()">Login</button> -->
  
            <button style="font-size: 14px; min-width: 40%;background-color: green;color: white; margin-right: 5%;" class="btn btn-outline-secondary rounded-pill button-align" (click)="login()">Login</button>
            <button style="font-size: 14px; min-width: 40%;" class="btn btn-outline-secondary rounded-pill button-align" (click)="closePop($event, false)">Cancel</button>
    
        </div>

    <div *ngIf="isLogin" class="full-width topPaddingForComp" style="height: 15%;display: flex;justify-content: center;align-items: center;font-size:small;">
               <span>Not a member yet?</span>
               <span style="text-align: end; color: #29088d; text-decoration: underline;" class="pointer-cursor" (click)="switchLogin(false)">Signup now</span>

    </div>

    <div *ngIf="isLogin" class="topPaddingForComp">

    </div>

    <div *ngIf="!isLogin" class="centerWithFlex full-width" style="height: 75%;">
        <div class="row zero-margin full-height full-width display-flex">
            <div class="grid-display full-width" style="height: 85%;">
                <div class=" full-width">
                    <div class="centerWithFlex full-width" style="height: 15%;">
                        
                        <div class="row zero-margin vert-center full-height full-width">
                            <label style="padding: 0px;font-size: medium;">First Name</label>
                            <div class="full-width vert-center zero-padding">
                                <!-- <span class="sgn-ref">First Name</span> -->
                                <input type="text" id="sgn-name" name="sgn-name" [tabIndex]="1" class="form-control sign-padding" (keyup)="handleSignName($event)" [(ngModel)]="signInfo.firstName">
                            </div>
                            <div class="full-width zero-padding display-flex sign-error">
                                <span *ngIf="signNameReq" class="sign-error-div">First name is required</span>
                            </div>
                        </div>
                    </div>
                    <div class="centerWithFlex full-width" style="height: 15%;">
                        <div class="row zero-margin vert-center full-height full-width">
                            <label style="padding: 0px;font-size: medium;">Last Name</label>
                            <div class="full-width vert-center zero-padding">
                                <!-- <span class="sgn-ref">Last Name</span> -->
                                <input type="text" id="lst-name" name="lst-name" [tabIndex]="1" class="form-control sign-padding" (keyup)="handleLastName($event)" [(ngModel)]="signInfo.lastName">
                            </div>
                            <div class="full-width zero-padding display-flex sign-error">
                                <span *ngIf="lastNameReq" class="sign-error-div">Last name is required</span>
                            </div>
                        </div>
                    </div>
                    <div class="centerWithFlex full-width" style="height: 15%;">
                        <div class="row zero-margin vert-center full-height full-width">
                            <label style="padding: 0px;font-size: medium;">Date of Birth</label>
                            <div class="full-width vert-center zero-padding">
                                <!-- <span class="sgn-ref">Date of Birth</span> -->
                                <input type="date" id="sgn-dob" name="sgn-dob" [tabIndex]="1" class="form-control sign-padding" (keyup)="handleDOB($event)" [(ngModel)]="signInfo.birthDate">
                            </div>
                            <div class="full-width zero-padding display-flex sign-error">
                                <span *ngIf="birthDateReq" class="sign-error-div">Date of birth is required</span>
                            </div>
                        </div>
                    </div>
                    <div class="centerWithFlex full-width" style="height: 15%;">
                        <div class="row zero-margin vert-center full-height full-width">
                            <label style="padding: 0px;font-size: medium;">Email</label>
                            <div class="full-width vert-center zero-padding">
                                <!-- <span class="sgn-ref">Email</span> -->
                                <input type="text" id="sgn-email" name="sgn-email" [tabIndex]="1" class="form-control sign-padding" (keyup)="handleEmail($event)" [(ngModel)]="signInfo.email">
                            </div>
                            <div class="full-width zero-padding display-flex sign-error">
                                <span *ngIf="emailReq" class="sign-error-div">Email is required</span>
                                <span *ngIf="emailAlreadyExists" class="sign-error-div">Email Already Exists</span>
                            </div>
                        </div>
                    </div>
                    <div class="centerWithFlex full-width" style="height: 15%;">
                        <div class="row zero-margin vert-center full-height full-width">
                            <label style="padding: 0px;font-size: medium;">Password</label>
                            <div class="full-width vert-center zero-padding">
                                <!-- <span class="sgn-ref">Password</span> -->
                                <input type="password" id="sgn-pwd" name="sgn-pwd" [tabIndex]="1" class="form-control sign-padding" (keyup)="handleSignPass($event)" [(ngModel)]="signInfo.signPassword">
                            </div>
                            <div class="full-width zero-padding display-flex sign-error">
                                <span *ngIf="signPasswordReq" class="sign-error-div">Password is required</span>
                            </div>
                        </div>
                    </div>
                    <div class="centerWithFlex full-width" style="height: 15%;">
                        <div class="row zero-margin vert-center full-height full-width">
                            <label style="padding: 0px;font-size: medium;">Confirm Password</label>
                            <div class="full-width vert-center zero-padding">
                                <!-- <span class="sgn-ref">Confirm Password</span> -->
                                <input type="password" id="sgn-cnf" name="sgn-cnf" [tabIndex]="1" class="form-control sign-padding" (keyup)="handleSignConfPass($event)" [(ngModel)]="signInfo.cnfPassword">
                            </div>
                            <div class="full-width zero-padding display-flex sign-error">
                                <span *ngIf="cnfPasswordReq" class="sign-error-div">Confirm Password is required</span>
                                <span *ngIf="cnfPasswordmatch" class="sign-error-div">Confirm Password Mismatched</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="full-width flex-end justify-center topPaddingForComp" style="height: 15%;">
                <!-- <button style="font-size: medium;background-color: green;color: white;width: 100%;" class="btn btn-outline-secondary  button-align" (click)="signUp()"> &nbsp; Signup</button> -->
           
           
                <button style="font-size: 14px; min-width: 40%;background-color: green;color: white; margin-right: 5%;" class="btn btn-outline-secondary rounded-pill button-align" (click)="signUp()">Signup</button>
                <button style="font-size: 14px; min-width: 40%;" class="btn btn-outline-secondary rounded-pill button-align" (click)="closePop($event, false)">Cancel</button>
    
            </div>
        </div>
    </div>

    <div *ngIf="!isLogin" class="full-width topPaddingForComp" style="height: 10%;display: flex;justify-content: center;align-items: center;font-size: small;">
        <span>Already A Member? &nbsp; </span>
        <span style="text-align: end; color: #29088d; text-decoration: underline;" class="pointer-cursor" (click)="switchLogin(true)">SignIn</span>

    </div>

    <div *ngIf="!isLogin" class="topPaddingForComp">

    
</div>